import { AxiosRequestConfig } from "axios";

export const getApplicationInfoConfig = (ApplicationId: string): AxiosRequestConfig => {
  return {
    method: "get",
    url: `/application/${ApplicationId}/status`,
  };
};
